import React from 'react'
import { Divider } from 'antd'
import { FlexContainer } from '@edulastic/common'
import {
  StyledSummaryDiscardButton,
  StyledSummaryHeading,
  StyledSummaryModal,
  StyledSummaryReviewButton,
} from './styled'

export default function PDFWarningModal({ isOpen, onClose, reset }) {
  return (
    <StyledSummaryModal
      visible={isOpen}
      width={450}
      style={{ minWidth: '450px' }}
      onCancel={onClose}
      footer={null}
    >
      <StyledSummaryHeading>PDF May Not Work Well</StyledSummaryHeading>
      <Divider type="horizontal" />
      <div style={{ padding: '10px' }}>
        <p style={{ marginBottom: '10px' }}>
          PDFs may not import text formatting and math expressions correctly.
        </p>
        <br />
        <p style={{ marginBottom: '10px' }}>
          For the best results, please upload a .docx version of your file.
        </p>
      </div>
      <FlexContainer justifyContent="center" gap="10px">
        <StyledSummaryReviewButton data-cy="continueWithPDF" onClick={onClose}>
          CONTINUE WITH PDF
        </StyledSummaryReviewButton>

        <StyledSummaryDiscardButton data-cy="uploadDocx" onClick={reset}>
          UPLOAD .DOCX FILE
        </StyledSummaryDiscardButton>
      </FlexContainer>
    </StyledSummaryModal>
  )
}
